module.exports = function(service) {
	'use strict'
	service.factory('getSubstringBetween', getSubstringBetween);
	getSubstringBetween.$inject = [];
	function getSubstringBetween() {
	    return function(string, startSubstring, endSubstring) {
            if (startSubstring && endSubstring) {
                var startIndex = string.indexOf(startSubstring);
                if (startIndex === -1) {
                    return null; // Start substring not found
                }
                var endIndex = string.indexOf(endSubstring, startIndex + startSubstring.length);
                if (endIndex === -1) {
                    return null; // End substring not found after start substring
                }
                return string.substring(startIndex + startSubstring.length, endIndex);
            } else if (startSubstring) {
                var startIndex = string.indexOf(startSubstring);
                if (startIndex === -1) {
                    return null; // Start substring not found
                }
                return string.substring(startIndex + startSubstring.length);
            } else {
                return null; // No substring provided
            }    
	    }
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/servicesModule/services/getSubstringBetweenService.js
// module id = 608
// module chunks = 0